import React from 'react';
import c from 'classnames';
import Icon from '../Icon';

// Name might be too generic, but the idea is that we can have multiple variations
// for list items. In the current HVC design system, we have already 3 designs of
// list items that have similarity in its content and function.

const ListItem = props => {
  const {
    title,
    subtitle,
    icon,
    link,
    className,
    onClick,
    descriptionId: customDescriptionId
  } = props;
  const classes = c('ListItem', className);
  const descriptionId = customDescriptionId || "listItem--".concat(new Date().toISOString(), "__subtitle");
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "ListItem__icon"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "ListItem__content"
  }, link ? /*#__PURE__*/React.createElement("a", {
    className: "ListItem__link",
    href: link,
    "aria-describedby": descriptionId,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("h3", {
    className: "ListItem__title"
  }, title)) : /*#__PURE__*/React.createElement("h3", {
    className: "ListItem__title"
  }, title), subtitle && /*#__PURE__*/React.createElement("span", {
    className: "ListItem__subtitle",
    id: descriptionId
  }, subtitle)), link && /*#__PURE__*/React.createElement(Icon, {
    icon: "keyboard_arrow_right_400",
    variant: "black",
    className: "ListItem__chevron"
  }));
};
export default ListItem;